export default __webpack_public_path__ + "static/monikap-d5b14b9abf150173a2c9a1e380f3e18d.png";